<div class="min-h-screen flex items-center justify-center bg-gray-100 p-4 dark:bg-black">
    <div
        class="flex w-full max-w-md rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 shadow-lg dark:bg-gray-900">
        <!-- Right Panel -->
        <div class="flex-1 bg-white dark:bg-gray-950 p-10 flex flex-col justify-center">
            <!-- Header -->
            <div class="mb-7 flex flex-col items-center">
                <div class="logo">
                    <img src="images/logo.png" alt="Logo" class="h-20 imageLogo">
                </div>
                <h4 class="text-[24px] font-bold font-serif text-gray-900 dark:text-white tracking-tight mb-1">
                    PexLens Control Plane
                </h4>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                    Sign in to manage your deployment
                </p>
            </div>

            @if (error)
            {
            <div class="bg-rose-100 flex items-center justify-center rounded-lg text-rose-500 py-2 mb-3"
                style="font-size:.85rem">{{error}}</div>
            }

            <!-- Form -->
            <form [formGroup]="loginForm" (ngSubmit)="onLogin()">

                <!-- Email -->
                <div class="mb-4">


                    <app-text-input [label]="'Email address'"
                        [inputClass]="'w-full px-3 py-2.5 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition'"
                        [id]="'email'" [type]="'email'" formControlName="email" [placeholder]="'you@workspace.com'"
                        [labelClass]="'block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5 tracking-wide uppercase'"
                        [autoFocus]="true"></app-text-input>
                </div>

                <!-- Password -->
                <div class="mb-4">
                    <div class="relative">
                        <app-text-input
                            [inputClass]="'w-full px-3 py-2.5 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition'"
                            [id]="'password'" [label]="'Password'" [type]="!showPassword ? 'password' : 'text'"
                            formControlName="password" [placeholder]="'••••••••'"
                            [labelClass]="'block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5 tracking-wide uppercase'"></app-text-input>

                        <button type="button" (click)="showPassword = !showPassword"
                            class="absolute right-3 top-2/3 -translate-y-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">

                            @if(!showPassword) {
                            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                stroke-width="1.8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            }

                            @if(showPassword) {
                            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                stroke-width="1.8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M3 3l18 18" />
                            </svg>
                            }
                        </button>
                    </div>
                </div>

                <!-- Remember Me -->
                <!-- <div class="flex items-center gap-2 mb-5">
                    <app-checkbox name="rememberMe" [value]="true" id="remember"
                        [labelClass]="'text-sm text-gray-500 dark:text-gray-400 cursor-pointer'"
                        [label]="'Keep me signed in for 30 days'" 
                        formControlName="rememberMe"></app-checkbox>
                </div> -->

                <!-- Submit -->
                <button type="submit" [disabled]="!loginForm.valid" class="w-full flex items-center justify-center gap-2 py-2.5 px-4 disabled:opacity-50 disabled:cursor-not-allowed text-white 
                    text-sm font-medium rounded-lg transition-colors active:scale-[0.99] login">
                    <!-- <svg class="w-4 h-4" viewBox="0 0 22 22" fill="none">
                        <circle cx="11" cy="11" r="8" stroke="white" stroke-width="1.5" />
                        <circle cx="11" cy="11" r="3.5" stroke="white" stroke-width="1.2" />
                        <circle cx="11" cy="11" r="1" fill="white" />
                    </svg> -->
                    Sign in
                </button>

            </form>
        </div>
    </div>
</div>